var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderleftbanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 80,
    viewBox: "0 0 100 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 100,
    height: 80,
    transform: "translate(725 0)",
    fill: "#214eb8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-725 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 34,
    height: 123,
    transform: "matrix(0.788, -0.616, 0.616, 0.788, 672.481, 6.932)",
    fill: "#214eb8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 34,
    height: 123,
    transform: "matrix(0.788, -0.616, 0.616, 0.788, 687.784, -34.996)",
    fill: "#214eb8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 34,
    height: 123,
    transform: "matrix(0.788, -0.616, 0.616, 0.788, 709.784, -69.996)",
    fill: "#214eb8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderleftbanner);
export default __webpack_public_path__ + "static/media/headerleftbanner.34dcb0c5685dfa8a99efe4ded1f11d52.svg";
export { ForwardRef as ReactComponent };